import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/b2b-data/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import DatabaseIntro from "../components/b2b-data/DatabaseIntro";
import WhyChooseUs from "../components/b2b-data/WhyChooseUs";
import FeaturesList from "../components/b2b-data/FeaturesList";
import Cta from "../components/b2b-data/Cta";
import Testimonials from "../components/b2b-data/Testimonials";

const B2BData = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <DatabaseIntro />
      <WhyChooseUs />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default B2BData;
